class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('header');
    this.hamburger = this.querySelector('.hamburger');
    this.drawer = this.querySelector('.nav-drawer');

    this.isScrolled = false;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    document.addEventListener('keydown', this.handleKeydown);

    if (this.hamburger) {
      this.hamburger.addEventListener('click', this.toggleDrawer);
    }

    const closeButton = this.querySelector('.drawer-close');
    if (closeButton) {
      closeButton.addEventListener('click', this.closeDrawer);
    }

    this.querySelectorAll('.drawer-link').forEach((link) => {
      link.addEventListener('click', this.closeDrawer);
    });

    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('keydown', this.handleKeydown);

    // 自分がドロワーを開いていた場合だけ復元する。無条件に空にすると、
    // body の overflow を触る別のコンポーネント（ライトボックスなど）が
    // 設定した hidden を横取りして解除してしまう。
    if (this.isDrawerOpen()) {
      document.body.style.overflow = '';
    }
  }

  isDrawerOpen() {
    return Boolean(this.drawer && this.drawer.classList.contains('open'));
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isDrawerOpen()) {
      this.closeDrawer();
    }
  }

  handleScroll() {
    const scrolled = window.scrollY > 50;
    if (scrolled === this.isScrolled) return;
    this.isScrolled = scrolled;
    if (this.header) this.header.classList.toggle('scrolled', scrolled);
  }

  toggleDrawer() {
    this.setDrawer(!this.isDrawerOpen());
  }

  closeDrawer() {
    this.setDrawer(false);
  }

  setDrawer(open) {
    if (!this.drawer || !this.hamburger) return;
    this.drawer.classList.toggle('open', open);
    this.hamburger.classList.toggle('open', open);
    this.hamburger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }
}

customElements.define('site-header', SiteHeader);
